import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";
// tslint:disable
export const yammer_praise_heart: React.FunctionComponent<ILeanSvgIconWithColor> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-heart" {...rest}>
      <title>praise-heart</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#F8AE41"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <path
        fill="#D1423B"
        d="M121.7 67.4c0 21.6-46.4 51.5-46.4 51.5S29 88 29 67.4c0-32 32.6-34.7 46.4-11.4 14.4-24.3 46.3-19.5 46.3 11.4z"
      ></path>
    </svg>
  );
};
